import React from "react";
import DateView from "react-datepicker";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePicker.styles.scss";
import Calendar from "../../Assets/calendar.svg";
import DateFnsUtils from "@date-io/date-fns";
import {MuiPickersUtilsProvider,KeyboardDatePicker} from "@material-ui/pickers";
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from "@material-ui/styles";

function DatePicker(props) {
  const { label, name, disabled, ...rest } = props;
  const defaultMaterialTheme = createTheme({
    palette: {
      type: 'dark',
      primary: {
        main: '#ffffff',
      },
      secondary: {
        main: '#f50057',
      },
      background: {
        default: '#1f1f1f',
      },
    },
  });
  return (
    <>
      <label className="xs-lable-select white" required>
        {label}
        <span style={{ color: "red" }}>{` *`}</span>
      </label>
      <div style={{ marginBottom: "2em", width: "8.9em" }} className="">
        <Field name={name}>
          {({ form, field }) => {
            const { setFieldValue } = form;
            const { value } = field;
            return (
              <>
                <div
                  className={`${
                    !disabled ? "datepicker_active" : "datepicker_inactive"
                  }`}
                >
                  <label style={{ position: "relative" }}>
                  <ThemeProvider theme={defaultMaterialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id={name}
                    {...field}
                      {...rest}
                    format="dd/MM/yyyy"
                    value={value}
                    minDate={props.minDate?props.minDate:null}
                    disabled={disabled}
                    invalidDateMessage=""
                    keyboardIcon={<img
                      alt=""
                      style={{
                        position: "absolute",
                        right: "0",
                        top: "0",
                        cursor: "pointer",
                        color: "white",
                      }}
                      src={Calendar}
                    />}
                    autoOk={true}
                    inputVariant="standard"
                    
                    fullWidth
                    onChange={(val)=>setFieldValue(name,val)}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
                </ThemeProvider>
                  </label>
                </div>
              </>
            );
          }}
        </Field>
        <ErrorMessage component={TextError} name={name} />
      </div>
    </>
  );
}

export default DatePicker;
